<template>
  <el-form-item :label="f.label">
    <el-input v-if="f.type == 'text'" v-model="f.value" type="text" :name="f.field" :id="f.field"></el-input>

    <el-input-number
      v-else-if="f.type == 'number'"
      v-model="f.value"
      controls-position="right"
      :name="f.field"
    ></el-input-number>

    <el-select
      v-else-if="f.type == 'select'"
      v-model="f.value"
      filterable
      :placeholder="f.label"
      :name="f.field"
    >
      <el-option
        v-for="item in f.options"
        :key="item.id"
        :value="item.id"
        :label="selectText(item)"
      ></el-option>
    </el-select>

    <el-select
      filterable
      v-else-if="f.type == 'select_multiple'"
      v-model="f.value"
      multiple
      :placeholder="f.label"
      :name="f.field"
      @change="changueItem($event, f.pivot)"
      @remove-tag="deleteItem($event, f.pivot)"
    >
      <el-option
        v-for="item in f.options"
        :key="item.id"
        :value="item.id"
        :label="selectText(item)"
      ></el-option>
    </el-select>
    <div v-else-if="f.type == 'date'">
      <el-date-picker
        v-model="f.value"
        :placeholder="f.label"
        :name="f.field"
        format="dd/MM/yyyy"
        :picker-options="pickerOptions1"
      ></el-date-picker>
    </div>

    <el-switch
      v-else-if="f.type == 'switch'"
      v-model="f.value"
      :placeholder="f.label"
      :name="f.field"
      :active-value="'1'"
      :inactive-value="'2'"
    ></el-switch>

    <el-checkbox-group v-else-if="f.type == 'checkbox'" v-model="f.value" :name="f.field">
      <el-checkbox border v-for="(item, i) in f.options" :key="i" :label="item.id">{{item.key}}</el-checkbox>
    </el-checkbox-group>

    <el-input v-else-if="f.type == 'textarea'" v-model="f.value" type="textarea" :name="f.field"></el-input>

    <el-color-picker v-else-if="f.type == 'color'" v-model="f.value" :name="f.field"></el-color-picker>

    <div v-else-if="f.type == 'image'">
      <input type="text" class="hidden" :id="f.field" :name="f.field" :value="f.value" />
      <app-cropper :options="options"></app-cropper>
    </div>
    <div v-else-if="f.type == 'file'">
      <el-upload
        ref="file"
        action
        :auto-upload="false"
        :multiple="false"
        :on-remove="handleRemove"
        :on-change="handleChange"
        :on-preview="handlePreview"
        :file-list="documento"
        :limit="1"
      >
        <el-button size="small" type="primary">Clic para cargar archivo</el-button>
      </el-upload>
    </div>
    <vue-editor
      v-else-if="f.type == 'texto_enriquecido'"
      v-model="f.value"
      :editorToolbar="customToolbar"
    ></vue-editor>
  </el-form-item>
</template>

<script>
import ApiService from "@/common/api.service";
import { API_UPLOADS, INTRANET_URL } from "@/common/config";

import { VueEditor } from "vue2-editor";
import Cropper from "@/components/Dashboard/commons/cropper";

export default {
  name: "itemForm",
  props: ["f", "options"],
  components: {
    VueEditor,
    "app-cropper": Cropper
  },
  created() {
    this.$route.params.id ? (this.id = this.$route.params.id) : false;
    if (this.f.key == "title") {
      // fix listado multifle, si el value es null
      if (!this.f.value) {
        this.f.value = [];
      }
    }
    if (this.f.type == "date" && this.f.value == "0000-00-00") {
      this.f.value = "";
    }
    if (
      this.f.type == "file" &&
      typeof this.f.value != "undefined" &&
      this.f.value != "" &&
      this.f.value != null
    ) {
      this.documento.push({ url: API_UPLOADS + this.f.value });
    }
  },
  data() {
    return {
      id: false,
      borrado: false,
      customToolbar: [
        [{ header: [false, 1, 2, 3, 4, 5, 6] }],
        ["bold", "italic", "underline", "strike"],
        [
          { align: "" },
          { align: "center" },
          { align: "right" },
          { align: "justify" }
        ],
        ["blockquote", "code-block"],
        [{ list: "ordered" }, { list: "bullet" }, { list: "check" }],
        [{ script: "sub" }, { script: "super" }],
        [{ indent: "-1" }, { indent: "+1" }],
        [{ color: [] }, { background: [] }],
        ["link", "formula"],
        [{ direction: "rtl" }]
      ],
      documento: [],
      folder: API_UPLOADS,
      pickerOptions1: {
        firstDayOfWeek: 1
      }
    };
  },
  methods: {
    handleRemove(file) {
      this.documento = [];
      this.$root.$emit("delete-doc", this.documento, this.f.field);
    },
    handleChange(file) {
      this.documento = [file];
      this.$root.$emit("load-doc", this.documento, this.f.field);
    },
    handlePreview(file) {
      window.open(file.url, "_blank");
    },
    selectText(i, o) {
      let k = Object.keys(i).filter(v => {
        return v != "id" ? v : false;
      });
      let label = "";
      k.map(e => {
        label = label + i[e] + " ";
      });
      return label;
    },
    deleteItem(e) {
      if (this.id) {
        this.borrado = e;
      }
    },
    changueItem(e, pivot) {
      let form = Object.create({});
      form[pivot[0].keys[0][1]] = this.id;
      form[pivot[0].keys[0][2]] = parseInt(e[e.length - 1]);
      setTimeout(() => {
        if (this.id) {
          if (this.borrado == false) {
            ApiService.post("dashboard/editform", {
              table: pivot[0].table,
              token: localStorage.getItem("token"),
              project_id: localStorage.getItem("table"),
              form: form
            }).then(response => {
              this.$root.$emit("msgSuccess", "Registro actualizado con éxito");
            });
          } else {
            ApiService.post("dashboard/delete", {
              table: pivot[0].table,
              token: localStorage.getItem("token"),
              project_id: localStorage.getItem("table"),
              k1: pivot[0].keys[0][1],
              k2: pivot[0].keys[0][2],
              k1id: this.id,
              k2id: this.borrado
            }).then(response => {
              this.$root.$emit("msgSuccess", "Registro actualizado con éxito");
            });
            this.borrado = false;
          }
        }
      }, 500);
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Dashboard/forms/itemForm.vue